import type { SourceType } from '@/api/hrms-sync';

export const TYPE_LABEL: Record<SourceType, string> = {
  core: 'Core',
  standard: 'Standard master',
  custom: 'Custom master',
  table: 'Table',
};

export function fmtWhen(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

/** A calendar date (`YYYY-MM-DD`), read as that day wherever the browser is. */
export function fmtDay(iso: string | null | undefined): string {
  if (!iso) return '—';
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return iso;
  return new Date(y, m - 1, d).toLocaleDateString(undefined, {
    day: 'numeric', month: 'short', year: 'numeric',
  });
}

export function fmtNum(n: number | null | undefined): string {
  return (n ?? 0).toLocaleString();
}

/** Case- and accent-insensitive "does any of these texts contain the query". */
export function matchesQuery(query: string, ...texts: (string | null | undefined)[]): boolean {
  // NFKD splits "é" into "e" + a combining mark (U+0300–U+036F), which is dropped.
  const norm = (s: string) => s.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase();
  const q = norm(query.trim());
  if (!q) return true;
  return texts.some((t) => !!t && norm(t).includes(q));
}
